import { useEffect, useState } from 'react'

import { useDelayedState } from './useDelayedState'
import { usePressEscKey } from './usePressEscKey'

export const useFullScreenMode = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { isDelayedState: isDelayedOpen } = useDelayedState(!isOpen)

  usePressEscKey(() => {
    setIsOpen(false)
  })

  const toggle = () => {
    setIsOpen((p) => !p)
  }

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
  }, [isOpen])

  return {
    isAnimationOpenFinished: !isDelayedOpen,
    isOpen,
    toggle,
  }
}
